import { defineComponent as _defineComponent } from 'vue'
import { ApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { ApprovalOvertimeWorkResponse } from "@/models/approval/ApprovalResponse";
import ApprovalTableBase, { HeaderType } from "./ApprovalTableBase.vue";
import { ref, onMounted, computed } from "vue";
import { $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { $confirm } from "@/plugins/confirm/confirm";
import { $alert } from "@/plugins/alert/alert";
import { useApproval } from "@/composable/Approval";
import OverworkDialog from "../form/OverworkDialog.vue";
import OverworkExpandItem from "../expand/OverworkExpandItem.vue";
import { Authority } from "@/models/enum/Enum";
import Vuex from "@/store/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'OvertimeWorkTable',
  setup(__props) {

const approval = useApproval();

const header: HeaderType = {
  key: "recordId",
  date: "overtimeWorkDate",
  user: "employeeName",
  affiliation: "affiliationName",
  approval: "approvalState"
};

const title = ref("残業申請承認");
const selected = ref<ApprovalOvertimeWorkResponse[]>([]);
const items = ref<ApprovalOvertimeWorkResponse[]>([]);
const form = ref<ApprovalSearchRequest>(approval.getForm());

const isDisabled = computed(() => {
  const authority = Vuex.state.authority;
  return authority < Authority.Accountant;
});

const getItems = async (request: ApprovalSearchRequest) => {
  const response = await $post<ApprovalOvertimeWorkResponse[]>(
    Paths.approval.overtimeWork.search,
    request
  );
  if (response) items.value = response;
};

const onSearch = async () => {
  await getItems(form.value);
};

const onResolve = async (
  items: ApprovalOvertimeWorkResponse[],
  selected: ApprovalOvertimeWorkResponse[]
) => {
  const message = `${items.length}件承認します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.overtimeWork.resolve, items);
  if (result && typeof result === "string" && !Number.isNaN(result)) {
    $alert("error", `${result}`);
    return;
  }
  if (result) $alert("success", `${result}件承認しました。`);
  await onSearch();

  console.log("selected", selected);
  selected = [];
};
const onReject = async (
  items: ApprovalOvertimeWorkResponse[],
  selected: ApprovalOvertimeWorkResponse[]
) => {
  const message = `${items.length}件却下します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.overtimeWork.reject, items);
  if (result) $alert("success", `${result}件却下しました。`);
  await onSearch();

  console.log("selected", selected);
  selected = [];
};

const onCancel = async (
  item: ApprovalOvertimeWorkResponse,
  selected: ApprovalOvertimeWorkResponse[]
) => {
  const message = "承認を取り消します。\nよろしいですか？";
  if (!(await $confirm(message))) return;

  const result = await $post(
    `${Paths.approval.overtimeWork.cancel}/${item.recordId}`
  );
  if (result) {
    $alert("success", "取消に成功しました。");
    await onSearch();

    console.log("selected", selected);
    selected = [];
  }
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,approval, header, title, selected, items, form, isDisabled, getItems, onSearch, onResolve, onReject, onCancel, ApprovalTableBase, OverworkDialog, OverworkExpandItem }
}

})